export default __webpack_public_path__ + "3e80432d736872e67b4f67625bc0c6cd.jpg";